/* global $, Moment */
'use strict';

// GrapesJS
let grapesjs = window.grapesjs = require('grapesjs');
require('grapesjs-preset-webpage');
require('./gjs-snd-blocks');

export default class CMSEditor {
  constructor(template, save_url, assets, upload) {
    let files = $.map(assets, file => {
      if (file.type && file.type.indexOf('image') >= 0) {
        return '//' + file.bucket + '.s3.amazonaws.com/' + file.link_url + 'thumb/' + file.file_name;
      }
      return;
    });
    let self = this;

    this.editor = grapesjs.init({
      container: '#gjs',
      components: template.components || template.html,
      style: template.style || template.css,
      storageManager: { 
        type: 'snd-storage',
        autosave: false,
      },
      colorPicker: {
        appendTo: 'parent',
        offset: { top: 20, left: -175 },
      },
      assetManager: {
        assets: files,
        upload: upload.url,
        uploadFile: (e) => {
          var files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
          for(var i=0; i < files.length; i++) {
            var fd = new FormData();
            fd.append('file-'+i, files[i]);
            fd.append('website_id', upload.website_id);
            fd.append('gallery_id', upload.data.gallery_id);
            fd.append('bucket', upload.bucket);
            fd.append('sid', upload.sid);

            $.ajax({
              method: 'POST',
              url: upload.url,
              data: fd,
              contentType:false,
              crossDomain: true,
              dataType: 'json',
              mimeType: "multipart/form-data",
              processData:false,
              success: function(result) {
                self.editor.AssetManager.add('//'+result.bucket+'.s3.amazonaws.com/'+result.link_url+'thumb/'+result.file_name);
              }
            });
          }
        }
      },
      plugins: ['gjs-preset-webpage', 'snd-blocks'],
      pluginsOpts: {
        'gjs-preset-webpage': {
          blocks: ['link-block', 'quote'],
          formsOpts: false,
          navbarOpts: false,
          blocksBasicOpts: {
            stylePrefix: 'gjs-',
            flexGrid: true
          }
        }
      }
    });

    this.editor.on('storage:start:store', function(obj) { 
      obj.title = $('#title').val();
      obj.slug = $('#slug').val();
      obj.meta_title = $('#meta-title').val();
      obj.meta_description = $('#meta-desc').val();
    });

    this.editor.StorageManager.add('snd-storage', {
      load: function (keys, cb, cbErr) {
        cb();
      },

      store: function(data, cb, cbErr) {
        var html = data['gjs-html'];

        if (!html) {
          throw new Error('Content is required');
        }

        var editorData = {
          components: JSON.parse(data['gjs-components']),
          style: JSON.parse(data['gjs-styles']),
          css: data['gjs-css']
        }

        $.ajax({
          type: 'POST',
          url: save_url,
          contentType: 'application/json',
          data: JSON.stringify({title: data['gjs-title'], page: html, slug: data['gjs-slug'], editor_data: editorData, meta_title: data['gjs-meta_title'], meta_description: data['gjs-meta_description']}),
          success: cb,
          error: cbErr
        });
      }
    });
  }

  store(cb, cbErr) {
    this.editor.store(cb, cbErr);
  }
} 